import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {
    DialogActionsEnum,
    DialogComponent,
    DialogConfigInterface,
    Pagination,
    ReportTableConfigInterface,
    ReportTableData,
    ReportTableDataRow
} from 'appShared/components';
import {MessageRecipientInterface} from '@spa/api';
import {AmsRecipientDataTableConfig, AmsRecipientDataTableItems, getRecipientRowIdByCustomer} from 'appAssets/descriptors';
import {
    AmsRecipientEmailSelector,
    AmsRecipientNameSelector,
    AmsRecipientSubjectIdSelector,
    AmsRecipientTenantIdSelector,
    AmsRecipientUserIdSelector,
    AmsRecipientUserRelationTypeSelector,
    AmsRecipientUserRelationTypeTxtSelector
} from 'appAssets/selectors';
import {Helper} from 'appShared/classes';

@Component({
    selector: 'app-recipient-list',
    templateUrl: './recipient-list.component.html'
})
export class RecipientListComponent extends DialogComponent<RecipientListComponent> implements OnInit {
    @Input() public recipients: MessageRecipientInterface[];
    public selectAll = true;
    public dataTableConfig: ReportTableConfigInterface;
    public currentPage = 1;
    public itemsPerPage = Pagination.defaultItemsPerPage;
    public totalItemCount = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            recipients: MessageRecipientInterface[]
        },
        public dialogRef: MatDialogRef<RecipientListComponent>,
    ) {
        super(dialogRef);
        this.config = data.config;
        this.recipients = data.recipients;
        this.totalItemCount = this.recipients.length;
    }

    private prepareRows(recipients: MessageRecipientInterface[]): ReportTableDataRow[] {
        return recipients.map((item: MessageRecipientInterface) => {
            const row = new ReportTableDataRow({
                checked: true,
                checkable: true,
                rowId: getRecipientRowIdByCustomer(item),
                dataItems: [],
                disabledActions: {},
            });

            row.dataItems = AmsRecipientDataTableItems().map((dataTableItem: ReportTableData) => {
                switch (dataTableItem.colId) {
                    case AmsRecipientSubjectIdSelector:
                        dataTableItem.value = item.id;
                        break;

                    case AmsRecipientUserIdSelector:
                        dataTableItem.value = item.customerId;
                        break;

                    case AmsRecipientUserRelationTypeSelector:
                        dataTableItem.value = item.customerType;
                        break;

                    case AmsRecipientUserRelationTypeTxtSelector:
                        dataTableItem.value = Helper.textsHelper().getUserRelationType(Number(item.customerType));
                        break;

                    case AmsRecipientNameSelector:
                        dataTableItem.value = item.fullName;
                        break;

                    case AmsRecipientEmailSelector:
                        dataTableItem.value = item.email;
                        break;

                    case AmsRecipientTenantIdSelector:
                        dataTableItem.value = item.tenantId;
                        dataTableItem.hidden = true;
                        break;

                }

                return dataTableItem;
            });

            return row;
        });
    }

    private getPageContentByPageNumber(page: number) {
        let startIndex = 0;
        let endIndex = this.itemsPerPage;

        if (page > 1) {
            endIndex = page * this.itemsPerPage;
            startIndex = endIndex - this.itemsPerPage;
        }

        return this.recipients.slice(startIndex, endIndex);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.dataTableConfig = AmsRecipientDataTableConfig(true);
        const currentPageRecipients = this.getPageContentByPageNumber(this.currentPage);
        this.dataTableConfig.rows = this.prepareRows(currentPageRecipients);
    }

    onPageChanged(page: number): void {
        this.currentPage = page;
        const currentPageRecipients = this.getPageContentByPageNumber(page);
        this.dataTableConfig.rows = this.prepareRows(currentPageRecipients);
    }

    selectAllRecipients(checked: boolean): void {
        this.dataTableConfig.rows.map((row: ReportTableDataRow) => row.checked = checked);
    }

    onFormSubmit(action?: number): void {
        if (action !== DialogActionsEnum.Confirm) {
            this.dialogRef.close(this.recipients);

            return;
        }

        const selectedRows = this.dataTableConfig.rows.map(row => {
            if (row.checked) {
                return this.recipients.find(
                    recipient => getRecipientRowIdByCustomer(recipient) === row.rowId
                );
            }

            return null;
        })?.filter(row => row !== null);

        this.dialogRef.close(selectedRows);
    }
}
